import { render, staticRenderFns } from "./NodeDetail.vue?vue&type=template&id=3a232416&scoped=true&"
import script from "./NodeDetail.vue?vue&type=script&lang=js&"
export * from "./NodeDetail.vue?vue&type=script&lang=js&"
import style0 from "./NodeDetail.vue?vue&type=style&index=0&id=3a232416&scoped=true&lang=css&"
import style1 from "./NodeDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a232416",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a232416')) {
      api.createRecord('3a232416', component.options)
    } else {
      api.reload('3a232416', component.options)
    }
    module.hot.accept("./NodeDetail.vue?vue&type=template&id=3a232416&scoped=true&", function () {
      api.rerender('3a232416', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/node/NodeDetail.vue"
export default component.exports